// 各モジュールのインポート
import { Accordion } from './modules/accordion';
import { Floating } from './modules/floating';
import { Modal } from './modules/modal';
import { Form } from './modules/form';
import { FormHandler } from './modules/plugContactForm';
import { ImgSwitcher } from './modules/imgswitch';
import { Animate } from './modules/animation';
import { Gnav } from './modules/nav';
import { hover } from './modules/hover';
import SmoothScroll from './modules/smoothScroll';
import { chart } from './modules/chart';
import { Tabs } from './modules/tab';
import swiperSlider from './modules/swiperSlider';
import text from './modules/text';
import selectLink from './modules/selectLink';
import ScrollItem from './modules/scrollItem';
import { initBarba } from './modules/barba';
import { generateTOC } from './modules/toc';

/**
 * ページ初期化処理
 */
function init() {
	initUtilities();   // ユーティリティ系の初期化（TOC、Swiper、テキスト加工など）
	initModules();     // 各モジュールの初期化
	initTabs();        // タブの初期化
	clearInlineStyles(); // 不要なCSSの削除
}

/**
 * 各モジュールの初期化
 */
function initModules() {
	const modules = [
		() => new Accordion('.js-accordion', 'pt01'),
		() => new Modal('.js-modal_content', '.js-modal_open_btn', '.js-modal_close_btn'),
		() => new Form(),
		() => new Floating(),
		() => new ImgSwitcher(),
		() => new Animate(),
		() => new hover(),
		() => new Gnav(),
		() => new ScrollItem(),
		() => new FormHandler(),
		() => new SmoothScroll(),
	];

	modules.forEach((moduleInit) => moduleInit());
}

/**
 * タブの初期化
 */
function initTabs() {
	const tabSelectors = ['#js-tab', '#js-tab02'];
	tabSelectors.forEach((selector) => {
		if ($(selector).length) {
			new Tabs(selector);
		}
	});
}

/**
 * 不要なCSSの削除
 */
function clearInlineStyles() {
	const cssSelectors = [
		'#flexible-table-block-inline-css',
		'#flexible-table-block-css',
	];
	cssSelectors.forEach((selector) => $(selector).empty());
}

/**
 * ユーティリティ系の初期化
 */
function initUtilities() {
	generateTOC();    // 目次生成
	selectLink();     // リンク選択系ユーティリティ
	text();           // テキスト加工系ユーティリティ
	swiperSlider();   // Swiperスライダー初期化
	chart();          // チャート初期化
}

/**
 * Barba.js の初期化（ページ遷移管理）
 */
initBarba(init);

// ページロード時の初期化
init();
